const CODIGO_TIPO_PRODUCTO_TERMINADO = 100;

/**
 * Payload para el alta rápida de un Producto Terminado (materiales_store.createMaterialRapidoHTTP).
 * Lo comparten el modal de asociación de productos y el alta rápida del drawer de selección.
 */
export const buildMaterialRapidoPayload = ({
  descripcion,
  codigoUnidadMedida,
  codigoEquivalente = null,
  codigoAdicional = null,
  clientes = [],
}) => ({
  CodigoMaterialTipo: CODIGO_TIPO_PRODUCTO_TERMINADO,
  MaterialTipo: { Codigo: CODIGO_TIPO_PRODUCTO_TERMINADO, Descripcion: 'Producto Terminado' },
  Tipo: 'Producto Terminado',
  DescripcionInterna: descripcion,
  DescripcionComercial: descripcion,
  DescripcionCliente: descripcion,
  CodigoUnidadMedida: codigoUnidadMedida,
  UnidadMedida: { Codigo: codigoUnidadMedida },
  CodigoEquivalente: codigoEquivalente || null,
  CodigoAdicional: codigoAdicional || null,
  Activo: true,
  MaterialClientes: clientes.map((codigoCliente) => ({ CodigoCliente: codigoCliente })),
});
